import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-product-details',
  templateUrl: './product-details.component.html',
  styleUrls: ['./product-details.component.scss']
})
export class ProductDetailsComponent implements OnInit {
  products:Map<string,{src:string,titre:string,url:string,image:string,description:string}>=new Map<string,{src:string,titre:string,url:string,image:string,description:string}>();
  currentProduct:string;
  product:{src:string,titre:string,url:string,image:string,description:string};
  constructor(private activatedRouter:ActivatedRoute) {
    this.products.set('mattress-ticking',
                        {src:'mattress.png',
                        titre:'Mattress weaving ticking jacquard Fabric',
                        url:'mattress-ticking',
                        image:'assets/img/photo/8.jpeg',
                        description:`<p>The core business of the group is the manufacture of mattress ticking fabrics which are used by industrial mattress manufacturers or by upholsterers and craftsmen.</p>
                        <ul>
                            <li>
                                <i class="icofont-check-circled"></i>
                                laminated fabric
                            </li>
                            <li>
                                <i class="icofont-check-circled"></i>
                                light fabric
                            </li>
                            <li>
                                <i class="icofont-check-circled"></i>
                                flat fabric
                            </li>
                            <li>
                                <i class="icofont-check-circled"></i>
                                quilted fabric
                            </li>
                            <li>
                                <i class="icofont-check-circled"></i>
                                waffle fabric
                            </li>
                        </ul>
                        `}
                    );
    this.products.set('stretch-fabrics',
                        {src:'stretch.png',
                        titre:'Mattress Knitting ticking jacquard Fabric',
                        url:'stretch-fabrics',
                        image:'assets/img/photo/ST-2.jpg',
                        description:`<p>Fine knit fabrics for high-end mattresses offer exceptional comfort, a silky touch and functional thermal and technical performance.</p>
                                    <p>These characteristics allow for luxurious, comfortable and restful mattresses.</p>
                                    <p>Our group is the first manufacturer of these luxury fabrics in Morocco, with the most efficient machines in the world and the latest generation.</p>`});
    this.products.set('tarpaulin-fabric',
                        {src:'tarp.png',
                        titre:'Tarpaulin fabric',
                        url:'tarpaulin-fabric',
                        image:'assets/img/photo/202.jpg',
                        description:'<p>The out door fabrics constitute an important segment for our group, we manufacture fabrics for tarpaulins, tents, and textile of protection and pleasure</p>'});

    this.products.set('decorative-fabric-tent',
                        {src:'tent.png',
                        titre:'Decorative tent Fabric',
                        url:'decorative-fabric-tent',
                        image:'assets/img/photo/tente.jpg',
                        description:`<p>The regal fabrics constitute a national imprint and tradition of national, event, family and popular celebrations.</p>
                                    <p>Caidal tents are spaces for meeting, sharing and exercising influence and power.</p>
                                    <p>The design, the patterns, the decorative elements are personalized, but the national imprint is always present.</p>`});
    // this.products.set('tapes-for-mattresses',
    //                     {src:'folded-ribbon.png',
    //                     titre:'Tapes for mattresses',
    //                     url:'tapes-for-mattresses',
    //                     image:'assets/img/photo/202.jpg',
    //                     description:'<p>We complete our range with tapes that allow the assembly and closing of mattresses.</p>'});

    this.products.set('technical-fabric',
                        {src:'cloth.png',
                        titre:'Technical Fabric',
                        url:'technical-fabric',
                        image:'assets/img/photo/technical_slide.jpeg',
                        description:'<p>We also manufacture fabrics with technical and functional characteristics for various uses.</p>'});
   }

  ngOnInit(): void {
    this.activatedRouter.params.subscribe(
        (params: Params)=>{
          if(params.categorie!=null){
            this.currentProduct=params.categorie;
            this.product=this.products.get(this.currentProduct);
          }
        }
    );
  }

}
